import { memo } from 'react'

import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

import { ProfileOptionProps } from '../types'

export const ProfileOption = memo(
  ({ item, isSidebarOpen, theme = 'light' }: ProfileOptionProps) => {
    const { icon, title, onClick } = item

    return (
      <li>
        <Tooltip delayDuration={200}>
          <TooltipTrigger
            className={cn(
              'h-12 w-full px-6 font-normal transition-all duration-200 [&_svg]:h-5 [&_svg]:w-5',
              isSidebarOpen ? 'justify-normal' : 'justify-center',
            )}
            asChild
          >
            <Button
              variant={theme === 'dark' ? 'botEnvironment' : 'ghost'}
              size="sm"
              onClick={onClick}
              className="text-[14px]"
              aria-label={title}
            >
              {icon}
              {isSidebarOpen && (
                <span
                  key="profile-option-title"
                  className="ml-2 overflow-hidden"
                >
                  {title}
                </span>
              )}
            </Button>
          </TooltipTrigger>

          <TooltipContent
            side="right"
            className={isSidebarOpen ? 'hidden' : 'text-sm'}
          >
            {title}
          </TooltipContent>
        </Tooltip>
      </li>
    )
  },
)

ProfileOption.displayName = 'ProfileOption'
